import { getAccountLookupForm, } from '@/store/modules/accountLookup';
export const getAccountType = () => {
    var _a;
    const localForm = getAccountLookupForm();
    return ((_a = localForm) === null || _a === void 0 ? void 0 : _a.userType) === 'teacher'
        ? 'ptk'
        : 'pd';
};
export const maskEmail = (email) => {
    const [first, last] = email.split('@');
    const firstLetter = first.charAt(0);
    const lastLetter = first.charAt(first.length - 1);
    const stars = Array.from({ length: first.length - 2 }, () => '*').join('');
    return `${firstLetter}${stars}${lastLetter}@${last}`;
};
